import AuthApiFactory from './apiFactory';

export default AuthApiFactory();
